<div class="app-header">
  <h1><a [routerLink]="'/'">{{ "header.title" | translate }}</a></h1>
</div>
